import DrawerAcore from '@/components/drawer-core';
import { useRef, useState, useMemo, forwardRef, useImperativeHandle } from 'react';
import { Space, Button } from 'antd';
import Dongdong from '@/components/dongdong';
import './index.less';
import Copy from '@/components/copy';
import utils from '@/common/utils';
import RejectReason from '@/components/reject-reason';
import { Link } from 'react-router-dom';

const DetailPop = ({ channelMicroStatusEvent = () => {}, data = {} }, ref) => {
  const popRef = useRef(null);
  const [visible, setVisible] = useState(false);
  const flag = useMemo(() => {
    const path = window.location.pathname.split('/');
    if (path.indexOf('my-manager') !== -1) {
      return 'MANAGE';
    }
    if (path.indexOf('my-approve') !== -1) {
      return 'APPROVE';
    }
  }, []);

  useImperativeHandle(
    ref,
    () => {
      return {
        show: () => {
          popRef.current.show();
        },
      };
    },
    []
  );

  function renderItem(item) {
    return item.map((key) => {
      return (
        <div className="micro-channel-detail-drawer__content__item" key={key.label}>
          <div className="micro-channel-detail-drawer__content__item__label">{key.label}：</div>
          <div className="micro-channel-detail-drawer__content__item__content">{key.content || '-'}</div>
        </div>
      );
    });
  }

  const rightItem = useMemo(() => {
    return [
      {
        label: '通天塔项目',
        content: data.towerName,
      },
      {
        label: '通天塔ID',
        content: <Copy>{data.towerId}</Copy>,
      },
      {
        label: '开始/结束时间',
        content:
          utils.formateTimeStamp(data.towerBeginTime, true) + ' ~ ' + utils.formateTimeStamp(data.towerEndTime, true),
      },
      {
        label: '页面主标题',
        content: data.mainTitle,
      },
      {
        label: '品类',
        content: data.category,
      },
      {
        label: '页面副标题',
        content: data.lessTitle,
      },
      {
        label: '运营语',
        content: data.pageTag,
      },
      {
        label: '选品规则',
        content: (
          <Link
            to={data.ruleId && `/batch-micro#/integration/manage?ruleId=${data.ruleId}`}
            target="_blank"
            rel="noopener"
          >
            查看规则
          </Link>
        ),
      },
    ];
  }, [data]);

  const leftItem = useMemo(() => {
    return [
      {
        label: '微频道名称',
        content: data.name,
      },
      {
        label: '创建方式',
        content: data.createType === 1 ? '通天塔' : '指南针',
      },
      {
        label: '微频道简介',
        content: data.remark,
      },
      {
        label: '微频道图片',
        content: <img src={data.pic} style={{ width: '80px', height: '80px' }} />,
      },
    ];
  }, [data]);

  return (
    <DrawerAcore
      title="微频道审核"
      height="65vh"
      ref={popRef}
      footerBtn={
        flag === 'APPROVE' && data.auditingStatus && (data.auditingStatus === 1 || data.auditingStatus === 4) ? (
          <Space size={16}>
            <Button
              onClick={
                () => {
                  setVisible(true);
                }
                //  popRef.current.hide()
              }
              shape="round"
            >
              {data.auditingStatus === 1 ? '入驻' : '上场'}驳回
            </Button>
            <Button
              type="primary"
              shape="round"
              onClick={() => {
                channelMicroStatusEvent({ channelId: data.channelId, operate: data.auditingStatus === 1 ? 2 : 5 });
                popRef.current.hide();
              }}
            >
              {data.auditingStatus === 1 ? '入驻' : '上场'}通过
            </Button>
          </Space>
        ) : null
      }
    >
      <div className="micro-channel-detail-drawer">
        <div className="micro-channel-detail-drawer__title">
          <span className="micro-channel-detail-drawer__title__text">{data.name}</span>
          <span className="micro-channel-detail-drawer__title__erp">
            微频道组长：
            <Dongdong name={data.ownerName} erp={data.ownerErp} />
          </span>
        </div>
        <div className="micro-channel-detail-drawer__content">
          <div className="micro-channel-detail-drawer__content__left">
            <div className="micro-channel-detail-drawer__content__left__title">
              <div>基本信息</div>
            </div>
            <div className="micro-channel-detail-drawer__content__left__content">{renderItem(leftItem)}</div>
          </div>
          <div className="micro-channel-detail-drawer__content__right">
            <div className="micro-channel-detail-drawer__content__right__title">
              <div>
                页面配置信息{' '}
                <a
                  style={{ fontWeight: 'normal', fontSize: '14px' }}
                  onClick={() => {
                    data.towerPageLink && window.open(data.towerPageLink, '_blank', 'noopener');
                  }}
                >
                  页面预览
                </a>
              </div>
            </div>
            <div className="micro-channel-detail-drawer__content__right__content">{renderItem(rightItem)}</div>
          </div>
        </div>
      </div>
      <RejectReason
        visible={visible}
        onCancel={() => setVisible(false)}
        onOk={(reason) => {
          channelMicroStatusEvent({ channelId: data.channelId, operate: data.auditingStatus === 1 ? 3 : 6, reason });
          setVisible(false);
          popRef.current.hide();
        }}
      />
    </DrawerAcore>
  );
};

export default forwardRef(DetailPop);
